import React from 'react';
import { FunnelIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const FilterPanel = ({ filters, onFilterChange, feeRanges = [], isMobileDrawer = false }) => {
 const cities = ['Lahore', 'Karachi', 'Islamabad', 'Peshawar'];
 const disciplines = ['Engineering', 'Business', 'Computer Science'];

 const handleFilterChange = (key, value) => {
 onFilterChange({ ...filters, [key]: value });
 };

 const filtersContent = (
 <div className="space-y-6">
 {/* City Filter */}
 <div>
 <label className="block text-sm font-semibold text-slate-700 mb-1.5">City</label>
 <div className="relative flex items-center">
 <select
 value={filters.city}
 onChange={(e) => handleFilterChange('city', e.target.value)}
 className="w-full border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 rounded-xl pl-3.5 pr-8 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 font-medium transition-all cursor-pointer appearance-none"
 >
 <option value="">All Cities</option>
 {cities.map((city) => (
 <option key={city} value={city}>{city}</option>
 ))}
 </select>
 <ChevronDownIcon className="h-4 w-4 absolute right-3 text-slate-500 pointer-events-none" />
 </div>
 </div>

 {/* Discipline Filter */}
 <div>
 <label className="block text-sm font-semibold text-slate-700 mb-1.5">Discipline</label>
 <div className="relative flex items-center">
 <select
 value={filters.discipline}
 onChange={(e) => handleFilterChange('discipline', e.target.value)}
 className="w-full border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 rounded-xl pl-3.5 pr-8 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 font-medium transition-all cursor-pointer appearance-none"
 >
 <option value="">All Disciplines</option>
 {disciplines.map((discipline) => (
 <option key={discipline} value={discipline}>{discipline}</option>
 ))}
 </select>
 <ChevronDownIcon className="h-4 w-4 absolute right-3 text-slate-500 pointer-events-none" />
 </div>
 </div>

 {/* Fee per semester Range Filter */}
 <div>
 <label className="block text-sm font-semibold text-slate-700 mb-1.5">Fee per semester Range</label>
 <div className="relative flex items-center">
 <select
 value={filters.feeRange}
 onChange={(e) => handleFilterChange('feeRange', e.target.value)}
 className="w-full border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 rounded-xl pl-3.5 pr-8 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 font-medium transition-all cursor-pointer appearance-none"
 >
 <option value="">Any Range</option>
 {feeRanges.map((range) => (
 <option key={range.value} value={range.value}>{range.label}</option>
 ))}
 </select>
 <ChevronDownIcon className="h-4 w-4 absolute right-3 text-slate-500 pointer-events-none" />
 </div>
 </div>

 {/* Deadline Filter */}
 <div>
 <label className="block text-sm font-semibold text-slate-700 mb-1.5">Application Deadline</label>
 <div className="relative flex items-center">
 <select
 value={filters.deadline}
 onChange={(e) => handleFilterChange('deadline', e.target.value)}
 className="w-full border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 rounded-xl pl-3.5 pr-8 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 font-medium transition-all cursor-pointer appearance-none"
 >
 <option value="">Any Time</option>
 <option value="30">Next 30 days</option>
 <option value="60">Next 60 days</option>
 <option value="90">Next 90 days</option>
 </select>
 <ChevronDownIcon className="h-4 w-4 absolute right-3 text-slate-500 pointer-events-none" />
 </div>
 </div>

 {/* Clear Filters */}
 <button
 onClick={() => onFilterChange({ city: '', discipline: '', feeRange: '', deadline: '' })}
 className="w-full btn-secondary text-sm"
 >
 Clear All Filters
 </button>
 </div>
 );

 if (isMobileDrawer) {
 return filtersContent;
 }

 return (
 <div className="card p-6 mb-6">
 <div className="flex items-center mb-4">
 <FunnelIcon className="h-5 w-5 mr-2 text-slate-600" />
 <h3 className="text-lg font-semibold">Filters</h3>
 </div>
 {filtersContent}
 </div>
 );
};

export default FilterPanel;